import Cookies from 'js-cookie'
import { isInjectToGeoTab } from '@/utils'

const TokenKey = 'Tenant-Token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    if (isInjectToGeoTab()) {
        return Cookies.set(TokenKey, token, {
            secure: true,
            sameSite: 'None'
        })
    } else {
        return Cookies.set(TokenKey, token)
    }
}

export function removeToken() {
    if (isInjectToGeoTab()) {
        return Cookies.remove(TokenKey, {
            secure: true,
            sameSite: 'None'
        })
    } else {
        return Cookies.remove(TokenKey)
    }
}